import { ScrollbarAdvanced } from './styles';

export default ScrollbarAdvanced;
